import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useEvent from '@src/hooks/useEvent';
import { TAB_OFFLINE_EVENT_CONSIDERATIONS } from '@src/const/event';

import HtmlParser from '@src/components/common/htmlParser';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';

const StyledBlockWrapper = styled(BlockWrapper)`
	padding-bottom: 40px;
	white-space: pre-wrap;
`;

const Considerations = (): JSX.Element => {
	const { t } = useTranslation();
	const { event: { considerations } } = useEvent();

	return (
		<StyledBlockWrapper id={TAB_OFFLINE_EVENT_CONSIDERATIONS}>
			<Header text={t(`event:${TAB_OFFLINE_EVENT_CONSIDERATIONS}`)} />
			<HtmlParser html={considerations} isCourse />
		</StyledBlockWrapper>
	);
};

export default Considerations;
